
export const callApp = jsonData => {
  return new Promise((resolve, reject) => {
    console.log('jsonData', jsonData)
    try {
      // ios
      var iOS = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
      if (iOS) {
        window.webkit.messageHandlers.app.postMessage(JSON.stringify(jsonData));
        resolve();
      } else {
        window.app.webcall(JSON.stringify(jsonData));
        resolve();
      }
    } catch (error) {
      // reject();
      console.log(`app交互失败：${JSON.stringify(error)}`);
    }
  });
};